<template>
    <a-layout id="home">
            <menus :menu="menu"/>
        <a-layout>
            <a-layout-header class="header">
                <a-row>
                    <a-col span="12"><a class="time"> {{getTime()}} </a></a-col>
                    <a-col span="12">
                        <a class="back">
                            <a-icon type="user" style="margin-right: 10px" title="登录人员"/>{{ userName }}
                            <a-icon type="home" style="margin-left: 20px" title="回到首页" @click="goBack"/>
                            <a-icon type="logout" style="margin-right: 10px;margin-left: 20px" title="退出" @click="getOut"/>
                        </a>
                    </a-col>
                </a-row>
            </a-layout-header>
            <a-layout-content class="content">
                <router-view/>
            </a-layout-content>
        </a-layout>
    </a-layout>
</template>

<script>
    import {getInfo} from '../module/login/ApiLogin'
    import menus from './Menu'
    import { getNowDateString } from '../config/Config'

    export default {
        components: {
            menus,
        },
        data() {
            return {
                menu:[],
                userName: ''
            }
        },
        methods:{
            getTime(){
                return getNowDateString()
            },
            getOut(){
                this.$router.push({name: 'login'})
            },
            goBack(){
                this.$router.push({name: '首页'})
            }
        },
        created() {
            const user = getInfo();
            this.userName = user.user.name;
            if (!user) {
                this.$router.push({name: 'login'})
            }else{
                this.menu=user.menu.data;
            }
        }
    }
</script>

<style scoped>
    #home {
        font-size: 18px;
        line-height: 48px;
        cursor: pointer;
        transition: color 0.3s;
        width: 100%;
        height: 100vh;
    }

    #home .header {
        background: #fff;
        height: 40px;
        line-height:40px;
        padding-left: 20px;
        padding-right: 20px;
    }

    #home .content {
        margin: 5px;
        background: #fff;
        padding: 5px;
    }
    img{
        width: 50px;
        height: 50px;
    }
    .time{
        font-size: 25px;
        float: right;
        color: #1890ff
    }
    .back{
        font-size: 20px;
        float: right;
        color: #666666
    }
</style>
